import config from "./config";

export * from "./config";

export default config;
